<template>
    <!-- 教辅资料 -->
    <div class="content">
        <el-dialog top="5vh" :title="title" :visible.sync="dialogFormVisible" @close="dialogFormVisible = false"
            :close-on-click-modal="false" width="620px">
            <el-form :model="dataForm" label-position="top" ref="dataForm" label-width="100px" size="small">
                <div v-for="(item, index) in subject_material_list" :key="index">
                    <el-form-item  prop="course_theme">
                        <div slot="label" class="formLable">
                            <div>专业课名称</div>
                            <el-link v-if="index!=0" @click="delProfessionalCourses(index)">删除</el-link>
                        </div>
                        <el-input v-model.trim="item.subject_name" placeholder="请输入专业课名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="教辅资料" prop="course_theme" v-for="(its, ins) in item.material_list" :key="ins">
                        <div class="area">
                            <el-input type="textarea" placeholder="例：孙发友：《新闻报道写作通论》，人民出版社，2006年版"
                                v-model="its.material_name">
                            </el-input>
                            <img :src="require('/src/assets/images/close.png')" alt="" v-if="ins != 0"
                                @click="delReferenceBook(index, ins)">
                        </div>
                    </el-form-item>
                    <div class="footer" v-if="index != subject_material_list.length - 1">
                        <el-button type="primary" icon="el-icon-plus" size="small" class="ele-btn"
                            @click="addReferenceBook(index)" plain>新增教辅资料</el-button>
                    </div>
                    <div v-else>
                        <div>
                            <el-button type="primary" icon="el-icon-plus" size="small" style="width: 100%;"
                                @click="addProfessionalCourses()" plain>新增专业课</el-button>
                        </div>
                        <div style="margin-top: 5px;">
                            <el-button type="primary" icon="el-icon-plus" size="small" style="width: 100%;"
                                @click="addReferenceBook(index)" plain>新增教辅资料</el-button>
                        </div>
                    </div>

                </div>
                <div class="footer">
                    <el-button @click="dialogFormVisible = false" size="small">取消</el-button>
                    <el-button type="primary" @click="submit" plain size="small">确定</el-button>
                </div>
            </el-form>

        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            subject_material_list: [],
            dataForm: {},
            dialogFormVisible: false,
            title: '教辅资料'
        }
    },
    created() {

    },
    methods: {
        open(data) {
            console.log(data)
            if (data && data.length > 0) {
                this.subject_material_list =JSON.parse(JSON.stringify(data))
            } else {
                this.subject_material_list = [
                    {
                        material_list: [{
                            material_name: ''
                        }],
                        subject_name: ""
                    }
                ]
            }
            this.dialogFormVisible = true
        },

        delProfessionalCourses(index) {
				this.subject_material_list.splice(index, 1)
			},
        // 提交
        submit() {
            this.subject_material_list = this.subject_material_list.filter(item => item.subject_name)
            this.subject_material_list.forEach((item, index) => {
                item.material_list = item.material_list.filter(its => its.material_name)
            })
            this.$emit('submit',this.subject_material_list)
            this.dialogFormVisible = false
        },
        delReferenceBook(index, ins) {
            this.subject_material_list[index].material_list.splice(ins, 1)
        },
        // 新增专业课
        addProfessionalCourses() {
            this.subject_material_list.push({
                material_list: [{
                    material_name: ''
                }],
                subject_name: ""
            })
        },
        addReferenceBook(index) {
            this.subject_material_list[index].material_list.push({
                material_name: ''
            })
        },
    }
}
</script>

<style lang="less" scoped>
.ele-btn {
    width: 100%;
    margin-top: -20px;
    margin-bottom: 15px;
}

.formLable{
    width: 580px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.area {
    position: relative;

    img {
        width: 16px;
        position: absolute;
        top: -5px;
        right: -5px;
        cursor: pointer;
    }


}
</style>